import { render, staticRenderFns } from "./dataPermissions.vue?vue&type=template&id=dfc6d472&scoped=true"
import script from "./dataPermissions.vue?vue&type=script&lang=js"
export * from "./dataPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc6d472",
  null
  
)

export default component.exports